export default url => {
    if (!url) {
        return []
    }
    return url.split('.')[0].replace('[', '').replace(']', '').split('|')
}